import { PromotionModel } from "@insite/client-framework/Types/ApiModels";

export function getOrderPromotions(promotions: PromotionModel[]) {
    return promotions.filter(
        promotion =>
            promotion.promotionResultType === "AmountOffOrder" || promotion.promotionResultType === "PercentOffOrder"|| promotion.promotionResultType === "FisscoPercentOffOrder" || promotion.promotionResultType === "FisscoAmountOffOrder",
    );
}